"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sustinente": {
    "7e2934fc": [{
      "hkey": "0db6bc07",
      "slug": "sacchetta-ca-vecchia",
      "name": "Sacchetta-Ca' Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-sacchetta": [{
      "hkey": "0db6bc07",
      "slug": "sacchetta-ca-vecchia",
      "name": "Sacchetta-Ca' Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sustinente"
    }],
    "b18b42dc": [{
      "hkey": "0db6bc07",
      "slug": "sacchetta-ca-vecchia",
      "name": "Sacchetta-Ca' Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "cavecchia": [{
      "hkey": "0db6bc07",
      "slug": "sacchetta-ca-vecchia",
      "name": "Sacchetta-Ca' Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sustinente"
    }],
    "47e15569": [{
      "hkey": "556cc658",
      "slug": "sustinente",
      "name": "Sustinente",
      "primary": true,
      "skipSearch": false
    }],
    "poletto": [{
      "hkey": "556cc658",
      "slug": "sustinente",
      "name": "Sustinente",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;